import React, { FC } from "react";
import Svg, { Line } from "react-native-svg";
import { theme } from "@lookiero/sty-psp-ui";

interface ItemLockSVGProps {
  readonly width: number;
  readonly height: number;
  readonly strokeWidth?: number;
}

const ItemLockSVG: FC<ItemLockSVGProps> = ({ width, height, strokeWidth = 2 }) => {
  const { colorBorderInputFocus } = theme();

  return (
    <Svg
      height={height}
      width={width}
      style={{
        position: "absolute",
      }}
    >
      <Line
        fill="none"
        id="line"
        stroke={colorBorderInputFocus}
        strokeWidth={strokeWidth}
        x1={width - strokeWidth / 2}
        x2={strokeWidth / 2}
        y1={strokeWidth / 2}
        y2={height - strokeWidth / 2}
      />
    </Svg>
  );
};

export { ItemLockSVG };
